import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { DealFinderLayout } from '@layout/DealFinderLayout/DealFinderLayout';
import { NoResults } from '@components/deal-finder/results/NoResults';
import { Heading } from '@components/deal-finder/results/Heading';
import { DealFinderResultsContainer } from '@components/search-results/deal-finder-results/DealFinderResults';
import { PageProps } from '@model/pages';
import { DealFinderState } from '@model/state';
import { getDealFinderState } from '@state/deal-finder/dealFinderSelectors';
import { performSearch } from '@state/deal-finder-results/dealFinderResultsOperations';
import { getDestinationSearchParams, getDestinationAirports, DestinationSearchParams } from '@util/destination';
import { setPartialSearch } from '@state/deal-finder/dealFinderOperations';
import { getDealFinderUrlParams } from '@util/deal-finder';
import { getAlgoliaParentDestinations, getAlgoliaMatchingDestinations } from '@state/algolia/algoliaSelectors';
import { setHotelPath } from '@state/hotel/hotelOperations';

export interface HotelsPageLayoutProps extends PageProps {
  path: string;
  display: string;
  airports: Array<string>;
  metaTitle: string;
  metaDescription: string;
}

export const HotelsPageLayout = (props: HotelsPageLayoutProps) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [hasSearched, setHasSearched] = useState(false);
  const { path, display, metaDescription, metaTitle, promoBannerTripType } = props;
  const dealFinder: DealFinderState = useSelector(getDealFinderState);
  const [_, __, ___, resort] = path.split('/');
  const algoliaDestinations = useSelector(
    resort ? getAlgoliaParentDestinations(path) : getAlgoliaMatchingDestinations(path)
  );

  useEffect(() => {
    dispatch(setHotelPath({ shouldSendDataLayer: false }));
    const destinationAirports = getDestinationAirports(algoliaDestinations);

    if (!hasSearched && algoliaDestinations.length > 0) {
      setHasSearched(true);
      const urlQuery = router.asPath.split('?')[1];
      const urlParams = getDealFinderUrlParams(urlQuery, destinationAirports);
      const defaultSearchParams = getDestinationSearchParams({
        display,
        path,
        destinations: algoliaDestinations
      } as DestinationSearchParams);
      const searchParams = {
        ...dealFinder,
        ...defaultSearchParams,
        ...urlParams
      };
      dispatch(setPartialSearch(searchParams));
      dispatch(
        performSearch({
          ...searchParams,
          destinations: [
            {
              path,
              display,
              airports: destinationAirports
            }
          ]
        })
      );
    }
  }, [algoliaDestinations]);

  return (
    <DealFinderLayout
      noResults={<NoResults />}
      topComponent={<Heading />}
      searchComponent={<DealFinderResultsContainer />}
      metaDescription={metaDescription}
      metaTitle={metaTitle}
      promoBannerTripType={promoBannerTripType}
    />
  );
};
